<template>
    <span class="time" :style="bckStyle"> {{hours}}:{{minutes}} </span>
</template>
<script>
    import {
        colors
    } from '../../settings.js';

    export default {
        name: "Time",
        debug: false,
        props: ['events', 'day', 'currentDay', 'numDay', 'holidays', 'selectedMonth', 'todaysMonth','selectedYear','todaysYear'],
        data() {
            return {
                minutes: "00",
                hours: "00",
                bckStyle: {
                    background: 'none',
                }
            }
        },
        watch: {
            events: function() {
                this.minutes = 0;
                this.hours = 0;

                if (this.events[this.day]) {
                    this.events[this.day].forEach((value) => {
                        var splitTime = value.duration.split(":");
                        this.minutes += Number(splitTime[1]);

                        if (this.minutes >= 60) {
                            this.hours++;
                            this.minutes -= 60;
                        }

                        this.hours += Number(splitTime[0]);
                    });
                }

                this.coloration();
                if (this.hours != 0 || this.minutes !=0){
                    this.coloration();
                }else if(this.selectedYear <= this.todaysYear && this.selectedMonth <= this.todaysMonth && this.day <= this.currentDay){
                    this.coloration();
                }else{
                    this.bckStyle.background = colors.NONE;
                }

                if (this.minutes < 10) {
                    this.minutes = "0" + this.minutes;
                }
                if (this.hours < 10) {
                    this.hours = "0" + this.hours;
                }
            },
            holidays: function (){
                if(this.holidays[this.day]){
                    this.coloration();
                }
            }
        },
        methods: {
            coloration: function() {
                if (this.numDay == 6 || this.numDay == 0 || this.holidays[this.day]) {
                    this.bckStyle.background = colors.NONE;
                } else if (this.hours === 7 && this.minutes === 0) {
                    this.bckStyle.background = colors.TIME_OK;
                } else {
                    this.bckStyle.background = colors.TIME_WRONG;
                }
            }
        }
    }
</script>

<style scoped>
    span {
        display: inline-block;
        height: auto;
        width: auto;
        margin-top: 2px;
        padding: 2px;
    }
</style>